export function validateWindowSize(breakpointValue) {
  const breakpoint = breakpointValue;
  return $(globalThis).width() >= breakpoint;
}

export function isLocalUrl(urlToCheck) {
  const clientPath = SITEBASEURL;
  return urlToCheck !== null && urlToCheck.includes(clientPath);
}

export function openNewTab(isLocal) {
  return isLocal ? '' : 'target="_blank"';
}

export function customSearchBar(searchPlaceholder) {
  $('.header .searchBox input').val('');
  $('.header .searchBox input').attr('placeholder', searchPlaceholder);
}

export function createCustomToggle() {
  const currentToggle = $(`.mobile-nav-toggle`);
  const closeToggle = $('.mobile-menu-container .close-mobile-menu');

  updateToggle();
  openMenuKeyboard();

  function updateToggle() {
    currentToggle.attr('tabindex', '0');
    for (let i = 0; i < 3; i++) {
      currentToggle.append("<span class='toggle-line'></span>");
    }
  }

  function openMenuKeyboard() {
    currentToggle.on('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && !$('body').hasClass('mobile-menu-open')) {
        $(this).trigger('click');
        closeMenuKeyboard();
      }
    });
  }

  function closeMenuKeyboard() {
    closeToggle.attr('tabindex', '0');
    closeToggle.focus();

    closeToggle.on('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && $('body').hasClass('mobile-menu-open')) {
        $(this).trigger('click');
      }
      currentToggle.focus();
    });
  }
}

export function cloneHeaderItems() {
  const $searchBox = $('.header .searchBox');
  $searchBox.find('.searchBoxSubmit .inputFieldSubmit:first').attr('tabindex', '-1');
}

export function updateContentMargin() {
  function applyMargin() {
    const headerHeight = $('header').outerHeight();

    const mq = globalThis.matchMedia('(max-width: 890px)');
    const additionalValue = mq.matches ? 40 : 60;

    const content = $('.content');
    const isHomepage = $('body').hasClass('homepage');

    content.css(
      'margin-top',
      isHomepage ? `${headerHeight}px` : `${headerHeight + additionalValue}px`,
    );
  }

  applyMargin();

  $(globalThis).on('resize', applyMargin);

  $(globalThis).on('scroll', function () {
    if ($(this).scrollTop() === 0) {
      setTimeout(applyMargin, 300);
    }
  });
}
